import axios from 'axios';
import { Link } from 'react-router-dom';
import PublishedAtInfo from '../utils/PublishedAtInfo';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import API_BASE_URL from '../../config';
import FeaturedImage from './FeaturedImage';

export type ArticleType = {
  _id: string;
  title: string;
  video?: string | null;
  content?: string | null;
  image: string | null;
  published: boolean;
  published_at: string;
  imageURL: string;
};

interface PublishedArticleContentProps {
  article: any; // Replace 'any' with the actual type of formik
  imageURL: string;
}

const PublishedArticle: React.FC<PublishedArticleContentProps> = ({ article }) => {
  const [data, setData] = useState<ArticleType>();
  const url = `/article/${article._id}/show`;
  const { t }: { t: (key: string, options?: any) => string } = useTranslation();


  useEffect(() => {
    const fetchData = async () => {
      try {
        const configuration = {
          url: API_BASE_URL + url,
          method: 'get',
          headers: {
            'Content-Type': 'application/json',
          },
        }

        axios.request<ArticleType>(configuration).then(
          (res) => {
            setData(res.data)
          }
          ).catch((err) => {
            console.error(err);
        });

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [url]); // Empty dependency array means this effect runs once on mount

  return (
    <div className="container mx-auto max-w-3xl lg:max-w-4xl px-4 md:px-6 lg:px-12">
      <section className="mb-6">
        <div className="ml-2 mb-2 flex items-center">
          <PublishedAtInfo published_at={String(article.published_at)} />
        </div>

        <div className="flex flex-col md:flex-row gap-6 items-start">
          {data?.imageURL && (
            <div className="w-1/3 md:w-1/4 aspect-square overflow-hidden rounded-lg">
              <FeaturedImage imageURL={data.imageURL} />
            </div>
          )}

          <div className="w-full md:w-3/4">
            <h1 className="mb-4 text-2xl md:text-3xl text-left">{article.title}</h1>
            <h4 className="mb-4 text-base md:text-lg text-gray-600 text-left">
              <div dangerouslySetInnerHTML={{ __html: `${article.subheading ?? ''}` }} />
            </h4>
            <div className="text-right mt-2">
              <Link
                className="inline-block border border-black text-black font-semibold px-4 py-2 rounded-lg hover:bg-black hover:text-white transition duration-300 shadow-lg"
                to={`/article/${article._id}/show`}
                state={{ article }}
              >
                {t('articles.continue_reading')}
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>

  )
}

export default PublishedArticle
